import { render } from "./BuildingOverviewModule.vue?vue&type=template&id=5c5c2b7c&scoped=true"
import script from "./BuildingOverviewModule.vue?vue&type=script&lang=js"
export * from "./BuildingOverviewModule.vue?vue&type=script&lang=js"

import "./BuildingOverviewModule.vue?vue&type=style&index=0&id=5c5c2b7c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5c5c2b7c"

export default script